import { useContext, useEffect, useState } from 'react';
import { ViContext } from '../../context/ViContext';
import { MapContext } from '../../context/MapContext';
import LabelIcon from '@mui/icons-material/Label';
import { quantileSggData, quantileEmdData } from '../../common/quantile';

import Map from './Map';
import { SvgIcon } from '@mui/material';
import { getLayersByKey } from '../../common/layer';
import Popup from '../popup/Popup';

function CommonMap(props) {
	const { mapMode, emdCode, selectSgg, selectEmd } = useContext(ViContext);
	const { createMap, sggMap, setSggMap, emdMap, setEmdMap } =
		useContext(MapContext);

	const [mapTitleSize, setMapTitleSize] = useState('normal');
	const [layers, setLayers] = useState(null);

	const handleMapZoomLevel = (handle) => {
		const value = handle === 'plus' ? 1 : -1;

		const targetMap = props.type === 'sgg' ? sggMap : emdMap;
		targetMap.getView().setZoom(targetMap.getView().getZoom() + value);
	};

	const onClickMapTit = (e) => {
		if (mapTitleSize === 'normal') {
			setMapTitleSize('small');
		} else {
			setMapTitleSize('normal');
		}
	};

	const arrowElement = () => {
		return (
			<div className="customArrow">
				<div className="customArrowTop" />
				<hr className="customArrowLine" />
				<div className="customArrowBottom" />
			</div>
		);
	};

	useEffect(() => {
		const sggLayers = getLayersByKey('sggLayers');
		const emdLayers = getLayersByKey('emdLayers');

		const { bgLayer: sggBgLayer, ...sggTargetLayers } = sggLayers;
		const { bgLayer: emdBgLayer, ...emdTargetLayers } = emdLayers;
		let map = null;

		if (props.type === 'sgg') {
			map = createMap('sggMap', sggBgLayer, sggTargetLayers);
			setSggMap(map);
			setLayers(sggLayers);
		} else if (props.type === 'emd') {
			map = createMap('emdMap', emdBgLayer, emdTargetLayers);
			setEmdMap(map);
			setLayers(emdLayers);
		}

		return () => {
			const mapEl = document.querySelector(
				props.type === 'sgg' ? '#sggMap' : '#emdMap'
			);
			if (mapEl && mapEl.hasChildNodes()) {
				mapEl.removeChild(mapEl.children[0]);
			}
		};
	}, []);

	useEffect(() => {
		if (layers && props.type === 'sgg') {
			const params = {
				STYLES: 'vi_sgg_' + selectSgg,
			};
			layers.vi_sgg.getSource().updateParams(params);
			layers.vi_sgg.getSource().refresh();
		}
	}, [selectSgg]);

	useEffect(() => {
		if (layers && props.type === 'emd') {
			const params = {
				STYLES: 'vi_emd_' + selectEmd,
			};
			layers.vi_emd.getSource().updateParams(params);
			layers.vi_emd.getSource().refresh();
		}
	}, [selectEmd]);

	const returnOriginLegend = () => {
		if (props.type === 'sgg') {
			return (
				<>
					{quantileSggData.color.map((cur, idx) => {
						return (
							<div
								className="legendItem"
								key={`origin_${quantileSggData.title[1]}_${idx}`}
							>
								<div
									className="legendItemColor"
									style={{ backgroundColor: cur }}
								/>
								<p className="legendItemName">{quantileSggData.legend[idx]}</p>
							</div>
						);
					})}
					{arrowElement()}
				</>
			);
		} else if (props.type === 'emd') {
			return (
				<>
					{quantileEmdData.color.map((cur, idx) => {
						return (
							<div className="legendItem" key={`origin_vi_emd_${idx}`}>
								<div
									className="legendItemColor"
									style={{ backgroundColor: cur }}
								/>
								<p className="legendItemName">{quantileEmdData.legend[idx]}</p>
							</div>
						);
					})}
					{arrowElement()}
				</>
			);
		}
	};

	return (
		<div id={`${props.type}Partition`} className={mapMode}>
			<Map id={`${props.type}Map`} zoomHandler={handleMapZoomLevel} />
			{mapTitleSize === 'normal' ? (
				<div
					className={props.type === 'emd' ? 'mapTit blueBG' : 'mapTit redBG'}
					onClick={(e) => {
						onClickMapTit(e);
					}}
				>
					{mapMode === 'origin'
						? props.type === 'emd'
							? '읍면동'
							: '시군구'
						: emdCode !== ''
						? '읍면동'
						: '시군구'}
				</div>
			) : (
				<div
					className=" titIcon"
					onClick={(e) => {
						onClickMapTit(e);
					}}
				>
					<SvgIcon component={LabelIcon} sx={{ fontSize: 30 }}></SvgIcon>
				</div>
			)}
			<div className="originMapLegend">{returnOriginLegend()}</div>
			<Popup type={props.type} />
		</div>
	);
}

export default CommonMap;
